export const env = process.env.ENV ? process.env.ENV : 'prod';
// logger.log(process.env.ENV);
// logger.log(process.env);

// Base urls
const BaseURLs = {
  dev: 'https://rahultempbe.thecarebox.in',
  harmeet: 'https://harmeetbe.thecarebox.in',
  sneh: 'https://snehbe.thecarebox.in',
  vimal: 'https://vimalbe.thecarebox.in',
  prajwal1: 'https://prajwalmonkbe.thecarebox.in',
  rohit: 'https://rohitbe.thecarebox.in',
  // stage: "https://rfwofeymj9.execute-api.ap-south-1.amazonaws.com/dev",
  stage: 'https://stageapi.monkcommerce.app',
  ocu: 'https://3wgxi4etme.execute-api.us-east-1.amazonaws.com',
  // prod: "https://zxtsbd2v6e.execute-api.us-east-1.amazonaws.com/prod",
  prod: 'https://api.monkcommerce.app',
  pika: 'https://pikabe.thecarebox.in',
};

const apiKey = {
  dev: 'b26aea7b4c200840d4ce859ef63be4d9',
  harmeet: '80f9991d92f9c487a2102d4194bc5b31',
  sneh: 'a00079351a203b11de635667a105212c',
  prajwal1: 'c0e34c343cd7986851e5a7beedd3a9c3',
  rohit: '235069e438e46116f7508127913473fa',
  vimal: 'bf412792042dc5f26e736cccd79715c2',
  stage: '3403f021d57bd64830a3824104cd148c',
  ocu: 'cc76957c114fc8924cdf8460bf8f4465',
  prod: '31a67b74175808b89b146d03a5cd8580',
  pika: '39ad71278a54f0149f33e48d70594e88',
};

const AdminURLs = {
  dev: 'https://harmeetadmin.thecarebox.in',
  sneh: 'https://snehadmin.thecarebox.in',
  rohit: 'https://rohitadmin.thecarebox.in',
  // stage: "https://stageupsell.monkcommerce.com",
  stage: 'https://stageupsell.monkcommerce.app',
  ocu: 'https://ocu.monkcommerce.app',
  prajwal1: 'https://prajwalmonkadmin.thecarebox.in',
  vimal: 'https://vimaladmin.thecarebox.in',
  // prod: "https://upsell.monkcommerce.com",
  prod: 'https://upsell.monkcommerce.app',
};

const logtailKey = {
  prod: {
    key: 'mcuwuV6VA9wo8Y1U2Hb61dUT',
    endpoint: 'https://s1252306.eu-nbg-2.betterstackdata.com',
  },
};

// const amplitudeKey = {
//   dev: "d5a4a1b2a435318b265e3bc7f1b0ea27",
//   stage: "d5a4a1b2a435318b265e3bc7f1b0ea27",
//   prod: "6a530290593349167f3d33db403f57b1",
// };

// const amplitudeInstanceName = {
//   dev: "devAppFE",
//   stage: "stageAppFE",
//   prod: "prodAppFE",
// };

const bugsnagKey = {
  prod: 'd4542c16d530fa1114d896371c046ea6',
};

export function getApiKey() {
  return apiKey[env];
}

export function getBugsnagKey() {
  return bugsnagKey[env];
}

export function getLogtailKey() {
  if (!logtailKey[env]) {
    return '';
  }
  if (!logtailKey[env].key) {
    return '';
  }
  return logtailKey[env].key;
}

export function getLogtailEndpoint() {
  if (!logtailKey[env]) {
    return '';
  }
  if (!logtailKey[env].endpoint) {
    return '';
  }
  return logtailKey[env].endpoint;
}

export const BaseURL = BaseURLs[env];
export const AdminURL = AdminURLs[env];

// export function getAmplitudeKey() {
//   return amplitudeKey[env];
// }

// export function getAmplitudeInstanceName() {
//   return amplitudeInstanceName[env];
// }
